import { Fragment, useState } from "react";
import StandardTwoSectionCard from "../../../../components/ui/cards/StandardTwoSectionCard";
import FiUnderstandingModal from "../utils/guides/modals/FiUnderstandingModal";
import ZPatternTwoSectionCard from "../../../../components/ui/cards/ZPatternTwoSectionCard";

function FiEcosytemZPattern({ content }) {
  const [activeFeatureKey, setActiveFeatureKey] = useState(null);
  const closeModalHandler = () => setActiveFeatureKey(null);

  return (
    <Fragment>
      <div className="fi-ecosystem-zpattern-container">
        {content.tools.map((tool) => (
          <ZPatternTwoSectionCard
            key={tool.key}
            heading_color={tool.heading_color}
            title_text={tool.label}
            bg_image={tool.bg_image}
            button_text={tool.cta}
            onButtonClick={() => setActiveFeatureKey(tool.key)}
          >
            <div className="card-content-wrapper">
              <h3>{tool.heading}</h3>
              <p className="card-description">{tool.description}</p>
              <ul className="card-bullets-list">
                {tool.features.map((feature) => (
                  <li className="card-bullet-item" key={feature}>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/icons/check_dark.svg`}
                      className="faq-card-icon"
                      alt={content.tool_card_check_icon_alt}
                    />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          </ZPatternTwoSectionCard>
        ))}
      </div>

      {activeFeatureKey && (
        <FiUnderstandingModal
          functionalityKey={activeFeatureKey}
          onClose={closeModalHandler}
        />
      )}
    </Fragment>
  );
}

export default FiEcosytemZPattern;
